"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var isAvailableLocalStorage = function isAvailableLocalStorage() {
  try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');
    return true;
  } catch (e) {
    return false;
  }
};
var customInterface = {
  memory: {},
  getItem: function getItem(key) {
    return this.memory[key];
  },
  removeItem: function removeItem(key) {
    delete this.memory[key];
  },
  setItem: function setItem(key, value) {
    this.memory[key] = value;
  }
};
var localStorageInterface = isAvailableLocalStorage() ? global.window.localStorage : customInterface;
var _default = exports.default = localStorageInterface;